import { Injectable } from '@angular/core';
import { MStaticClient, MStaticInter, MStaticFilter } from '@argalis-apps/models';
import * as moment from 'moment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { CommunicationConfigService, ConfigService } from '@argalis-apps/angular-global';
import * as TEST from './data-test';
@Injectable({
  providedIn: 'root'
})
export class StaticService {
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private communicationConfigService: CommunicationConfigService
  ) {}

  getStaticInfo(
    isInter: boolean,
    staticRequest: MStaticClient.IStaticClientRequest | MStaticInter.IStaticInterRequest,
    id: number
  ): Observable<MStaticClient.IStaticClientInfo | MStaticInter.IStaticInterInfo> {
    if (this.configService.getOptions().useTestData === true) {
      if (isInter) {
        return of(TEST.TEST_ISTATICInterInfo);
      } else {
        return of(TEST.TEST_IStaticClientInfo);
      }
    } else {
      let params = new HttpParams();
      params = params.set('listeSessionStatut', (staticRequest.listeSessionStatut || []).join());
      params = params.set('dateDebutPeriode', staticRequest.dateDebutPeriode);
      params = params.set('dateFinPeriode', staticRequest.dateFinPeriode);
      if (staticRequest.listeProduitSecteur.length !== 0)
        params = params.set('listeProduitSecteur', (staticRequest.listeProduitSecteur || []).join());
      if (staticRequest.listeProduit) params = params.set('listeProduit', (staticRequest.listeProduit || []).join());
      if (staticRequest.listeProduitFamille.length !== 0)
        params = params.set('listeProduitFamille', (staticRequest.listeProduitFamille || []).join());

      if (staticRequest.listeProduitGroupe.length !== 0)
        params = params.set('listeProduitGroupe', (staticRequest.listeProduitGroupe || []).join());

      if (isInter) {
        params = params.set('idIntervenant', id.toString());
        return this.http.get<MStaticClient.IStaticClientInfo | MStaticInter.IStaticInterInfo>(
          `${this.communicationConfigService.getApiUri()}/static/inter-info`,
          { params }
        );
      } else {
        const staticClientRequest = staticRequest as MStaticClient.IStaticClientRequest;
        params = params.set('listIdClient', id.toString());
        if (staticClientRequest.listeSite.length !== 0)
          params = params.set('listeSite', (staticClientRequest.listeSite || []).join());
        return this.http.get<MStaticClient.IStaticClientInfo | MStaticInter.IStaticInterInfo>(
          `${this.communicationConfigService.getApiUri()}/static/client-info`,
          { params }
        );
      }
    }
  }

  getStaticInfoCard(
    isInter: boolean,
    id: number
  ): Observable<MStaticClient.ICardVisualisationClient | MStaticInter.IStatistiqueCardVisualisationInter> {
    if (this.configService.getOptions().useTestData === true) {
      if (isInter) {
        return of(TEST.TEST_visualtionInter);
      } else {
        return of(TEST.TEST_visualtionClient);
      }
    } else {
      let params = new HttpParams();
      if (isInter) {
        params = params.set('idIntervenant', id.toString());
        return this.http.get<MStaticClient.ICardVisualisationClient | MStaticInter.IStatistiqueCardVisualisationInter>(
          `${this.communicationConfigService.getApiUri()}/static/inter-info/card-visualisation`,
          { params }
        );
      } else {
        params = params.set('idClient', id.toString());
        return this.http.get<MStaticClient.ICardVisualisationClient | MStaticInter.IStatistiqueCardVisualisationInter>(
          `${this.communicationConfigService.getApiUri()}/static/client-info/card-visualisation`,
          { params }
        );
      }
    }
  }

  changeDate(code: MStaticFilter.ECode): MStaticFilter.CPeriod {
    switch (code) {
      case MStaticFilter.ECode.ANN:
        return {
          dateBeginPeriode: moment()
            .startOf('year')
            .format('YYYY-MM-DD'),
          dateEndPeriod: moment()
            .endOf('year')
            .format('YYYY-MM-DD')
        };
      case MStaticFilter.ECode.MOIS:
        return {
          dateBeginPeriode: moment()
            .startOf('month')
            .format('YYYY-MM-DD'),
          dateEndPeriod: moment()
            .endOf('month')
            .format('YYYY-MM-DD')
        };
      case MStaticFilter.ECode.SEM:
        switch (moment().quarter()) {
          case 1:
          case 3:
            return {
              dateBeginPeriode: moment()
                .startOf('quarter')
                .format('YYYY-MM-DD'),
              dateEndPeriod: moment()
                .add(3, 'months')
                .endOf('quarter')
                .format('YYYY-MM-DD')
            };
          case 2:
          case 4:
            return {
              dateBeginPeriode: moment()
                .subtract(3, 'months')
                .startOf('quarter')
                .format('YYYY-MM-DD'),
              dateEndPeriod: moment()
                .endOf('quarter')
                .format('YYYY-MM-DD')
            };
          default:
            return null;
        }
      case MStaticFilter.ECode.TRI:
        return {
          dateBeginPeriode: moment()
            .startOf('quarter')
            .format('YYYY-MM-DD'),
          dateEndPeriod: moment()
            .endOf('quarter')
            .format('YYYY-MM-DD')
        };
      default:
        return null;
    }
  }

  parseDate(date: Date): string {
    return moment(date).format('YYYY-MM-DD');
  }
}
